module.exports = __webpack_public_path__ + "img/ic_link_set.75db7e5d.svg";